/**
 * <TextFilter />
 *
 * @parent anybody
 * @stateful
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'
import ResettableInput from 'components/UI/Inputs/ResettableInput';

const DEFAULT_PLACEHOLDER = __('Search', 'TextFilter');

const VALUE_MIN_LENGTH = 3;

class TextFilter extends React.Component {
  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(props) {
    super(props);

    this.state = {
      value: '',
      hasMeaningfulValue: false,
    }

    this.onReset = this.onReset.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  onReset() {
    const { onReset } = this.props;

    this.setState({
      value: '',
      hasMeaningfulValue: false,
    }, ()=>{
      onReset();
    });
  }

  //
  // Ryan: It works but I didn't write logic explicitly. Please refer to the comments.
  //
  onChange(e) {
    const value = e.target.value || '';

    const { onChange } = this.props;

    const {
      valueMinLength = VALUE_MIN_LENGTH,
    } = this.props.options;


    this.setState({
      value,
    }, ()=>{
      clearTimeout(this.filterTimeout);
      this.filterTimeout = setTimeout(()=>{
        // console.log(value, value.length < valueMinLength);
        if (value.length >= valueMinLength) {
          this.setState({
            hasMeaningfulValue: true,
          }, ()=>{
            onChange(value);
          });
        } else if (this.state.hasMeaningfulValue && value.length < valueMinLength) {
          this.setState({
            hasMeaningfulValue: false,
          }, ()=>{
            this.props.onReset();
          });
        }
      }, 500);
    });

  }

  componentWillReceiveProps({ value }) {
    this.setState({
      value: value
    });
    if(value === ''){
      this.setState({hasMeaningfulValue: false})
    } else if (value) {
      this.setState({hasMeaningfulValue: true})
    }
  }

  render() {
    const {
      onReset,
      onChange,
      disabled,
    } = this.props;

    const {
      value,
      hasMeaningfulValue,
    } = this.state;

    const {
      placeholder,
    } = this.props.options;

    return (
      <div className='filter-by-field'>
        <ResettableInput
          placeholder={placeholder || DEFAULT_PLACEHOLDER}
          hasMeaningfulValue={hasMeaningfulValue}
          value={value}
          onReset={this.onReset}
          onChange={this.onChange}
          disabled={disabled}
        />
      </div>
    )
  }
}

export default TextFilter;



// WEBPACK FOOTER //
// ./src/template/FilterBy/filters/TextFilter.js